import { render, staticRenderFns } from "./chat_model_selector.vue?vue&type=template&id=d51acf56"
import script from "./chat_model_selector.vue?vue&type=script&lang=js"
export * from "./chat_model_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports